import React, { ReactNode } from "react";
import { NumericFormat } from "react-number-format";

import { VolumeAnalysisDatainner } from "./VolumeAnalysisDatainner";

import "./AccountingPeriodStats.scss";

type AccountingPeriodStatsProps = {
  VolumeAnalysisDatainner: VolumeAnalysisDatainner;
};

export class AccountingPeriodStats extends React.Component<AccountingPeriodStatsProps> {
  amount(value: any) {
    return (
      <NumericFormat
        value={value}
        displayType={"text"}
        decimalSeparator={","}
        thousandSeparator={" "}
        decimalScale={0}
        fixedDecimalScale={true}
      />
    );
  }

  render(): ReactNode {
    const data = this.props.VolumeAnalysisDatainner;
    return (
      <div className="wrapper">
        <div className="number">{this.amount(data.voucher_count_total)}</div>
        <div className="number">
          {this.amount(data.transaction_count_total)}
        </div>
        <div className="number">{this.amount(data.revenue)}</div>
        <div className="number">{this.amount(data.gross_margin)}</div>
        <div className="number">{this.amount(data.ebit_revenue)}</div>
        <div className="number">
          {this.amount(Math.abs(data.balance_sheet_total))}
        </div>
        <div className="number">
          {this.amount(data.zero_account_transaction_count)}
        </div>
      </div>
    );
  }
}
